import * as React from "react";
import {
  NavigationHelpersContext,
  useNavigationBuilder,
  StackRouter,
  StackRouterOptions,
  DefaultNavigatorOptions,
  createNavigatorFactory,
} from "@react-navigation/core";
import ScreenLayout from "./components/ScreenLayout";
import { Persona } from "./types";
import { WithOnboardedUser } from "./components/WithOnboardedUser";

const ScreenLayoutNavigator: React.FC<
  DefaultNavigatorOptions<StackRouterOptions> & { persona: Persona }
> = ({ children, screenOptions, initialRouteName, persona }) => {
  const { state, navigation, descriptors } = useNavigationBuilder(StackRouter, {
    children,
    screenOptions,
    initialRouteName,
  });

  return (
    <NavigationHelpersContext.Provider value={navigation}>
      <WithOnboardedUser>
        <ScreenLayout persona={persona}>
          {descriptors[state.routes[state.index].key].render()}
        </ScreenLayout>
      </WithOnboardedUser>
    </NavigationHelpersContext.Provider>
  );
};

export default ScreenLayoutNavigator;

export const createScreenLayoutNavigator = createNavigatorFactory(
  ScreenLayoutNavigator
);
